export default "__VITE_ASSET__p3RZS5bp__"